import Vue from 'vue'
import Router from 'vue-router'
import authRoutes from './auth'
import publicRoutes from './public'
import adminRoutes from './admin'
import { DEFAULT_TITLE } from './const'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/dadosabertos/',
  routes: [...authRoutes, ...publicRoutes, ...adminRoutes]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE

  if (to.name === 'Logout') {
    Logout.logout(router.app, next)
    return
  }

  next()

  // var authUser = false
  // if (localStorage.getItem('daUser') !== '') {
  //   authUser = JSON.parse(localStorage.getItem('daUser'))
  // }
  // if (from.name === 'Login' && to.path === '/admin') {
  //   if (authUser.perfis.indexOf('admin') > -1) {
  //     next()
  //   } else if (authUser.perfis[0].indexOf('default') > -1) {
  //     next('/user')
  //   }
  // } else {
  //   if (to.meta.requiresAuth) {
  //     if (!authUser || !authUser.token) {
  //       next({
  //         name: 'Login'
  //       })
  //     } else {
  //       if (to.meta.adminAuth) {
  //         if (authUser.perfis.indexOf('admin') > -1) {
  //           next()
  //         } else {
  //           next({
  //             name: 'Login'
  //           })
  //         }
  //       } else if (to.meta.userAuth) {
  //         if (authUser.perfis[0].indexOf('default') > -1 ||
  //           authUser.perfis[0].indexOf('admin') > -1) {
  //           next()
  //         } else {
  //           next({
  //             name: 'Login'
  //           })
  //         }
  //       }
  //     }
  //   } else {
  //     next()
  //   }
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js